import ServiceCategories from 'pages/ga/serviceCategories/Index';
import ServiceCategoriesForm from 'pages/ga/serviceCategories/Form';

const ServiceCategoriesRoutes = [
    { index: true, element: <ServiceCategories /> },
    {
        path: 'add',
        element: <ServiceCategoriesForm mode="add" />,
    },
    {
        path: 'edit/:id',
        element: <ServiceCategoriesForm mode="edit" />,
    },
];

export default ServiceCategoriesRoutes;
